import { useState, useCallback, useMemo } from 'react'
import { Campaign } from '@interfaces'

interface UseVideoPlayerStateProps {
  campaign: Campaign
  isEditPage: boolean
  analitycsIdentityValue: any
}

export const useVideoPlayerState = ({ campaign, isEditPage, analitycsIdentityValue }: UseVideoPlayerStateProps) => {
  const [showViralLoop, setShowViralLoop] = useState(false)
  const [replayVideo, setReplayVideo] = useState(false)

  // Check if viral modal should be open
  const isViralModalOpen = useMemo(() => {
    return !isEditPage && // Not avaiable on edit page
      !!campaign?.sendsparkBrandingEnabled && // Visible on paid plan and branding is enabled
      !(analitycsIdentityValue as any).userId && // Not visible for logged in users
      (campaign?.isFreeWorkspace || false) && // Not visible for paid plans
      showViralLoop
  }, [isEditPage, campaign, analitycsIdentityValue, showViralLoop])

  const handleOnReplay = useCallback(() => {
    setShowViralLoop(false)
    setReplayVideo(true)
  }, [])

  return {
    showViralLoop,
    setShowViralLoop,
    replayVideo,
    setReplayVideo,
    handleOnReplay,
    isViralModalOpen
  }
}